/**
 * creates type const to be used in action creators
 * @param prefix
 * @param typeName
 * @returns {string}
 */
export const getType = (prefix = 'app', typeName) => `${prefix}/${typeName}`;

export const getActionCreator =
  (type) =>
  (payload = {}) => ({
    type,
    payload,
  });
